import { render, staticRenderFns } from "./buyerIndex.vue?vue&type=template&id=30ab7e06&scoped=true&"
import script from "./buyerIndex.vue?vue&type=script&lang=js&"
export * from "./buyerIndex.vue?vue&type=script&lang=js&"
import style0 from "./buyerIndex.vue?vue&type=style&index=0&id=30ab7e06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ab7e06",
  null
  
)

export default component.exports